

export const divisions = [
    {
        title: "Список сотрудников",
        description: "Список сотрудников подразделения",
        // icon: blankList,
        path: "/divisions/structure/employee-list",
    },
    {
        title: "Замещение",
        description: "Передача полномочий руководителя на сотрудника",
        // icon: blankList,
        // path: "#",

        path: "/divisions/structure/delegation",
    },
    {
        title: "Делегирование полномочий",
        description: "Передача полномочий руководителя на сотрудника",
        // icon: blankList,
        path: "/divisions/structure/request-delegation",
    },
    // {
    //     title: "Штатное замещение",
    //     description: "Штатное расписание подразделения",
    //     // icon: blankList,
    //     path: "#",
    // },
];
